export default {
	errorAssigningTeam: "An error has occurred while assigning a meeting to a team. Please try again.",
	errorUnassigningTeam: "An error has occurred while unassigning a meeting from a team. Please try again.",
	errorLoadingTeamChoices: "Something went wrong when loading team choices. Please try refreshing the page to populate.",
	errorLoadingTeamlessMeetings: "Something went wrong when loading teamless meeting inbox. Please try refreshing the page to populate.",
};
